import { readonly, ref } from 'vue';

const steps = ref(null);

export const setStepsState = _steps => {
  steps.value = _steps;
};

export const stepsState = readonly(steps);
